import clsx from 'clsx'
import React from 'react'

import {default as HeaderButton} from '../header-button/HeaderButton'
import {listClasses} from './DropdownList.classes'
import {DropdownListProps} from './DropdownList.types'

export function DropdownList({list, className}: DropdownListProps) {
  return (
    <ul className={clsx(listClasses.countryList, className)}>
      {list.map((item, index) => {
        return (
          <li key={`${item.href}-${index}`} className={listClasses.listItem}>
            <HeaderButton href={item.href} size="s" variant="pseudo">
              {item.label}
            </HeaderButton>
          </li>
        )
      })}
    </ul>
  )
}
